'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _utilsAccessibility = require('@bibliocommons/utils-accessibility');

var _expandButton = require('../../expand-button');

var _expandButton2 = _interopRequireDefault(_expandButton);

require('../styles/ExpandableList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandableList = function (_BcReactComponent) {
  _inherits(ExpandableList, _BcReactComponent);

  function ExpandableList(props) {
    _classCallCheck(this, ExpandableList);

    var _this = _possibleConstructorReturn(this, (ExpandableList.__proto__ || Object.getPrototypeOf(ExpandableList)).call(this, props));

    _this.state = {
      expanded: false
    };
    _this.bindAll('renderListItem', 'handleToggle');
    _this.firstExpandedItem = null;
    return _this;
  }

  _createClass(ExpandableList, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.expanded && this.state.expanded && this.firstExpandedItem) {
        (0, _utilsAccessibility.setFocusWithinElement)(this.firstExpandedItem);
      }
    }
  }, {
    key: 'handleToggle',
    value: function handleToggle() {
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: 'renderExpandButton',
    value: function renderExpandButton() {
      var _props = this.props,
          list = _props.list,
          collapseCount = _props.collapseCount,
          renderExpandButtonLabel = _props.renderExpandButtonLabel;

      if ((list.length || list.size) > collapseCount) {
        return _react2.default.createElement(_expandButton2.default, { handleToggle: this.handleToggle, expanded: this.state.expanded, renderLabel: renderExpandButtonLabel });
      }

      return null;
    }
  }, {
    key: 'renderListItem',
    value: function renderListItem(item, index) {
      var _this2 = this;

      var _props2 = this.props,
          collapseCount = _props2.collapseCount,
          itemClassName = _props2.itemClassName,
          getItemKey = _props2.getItemKey,
          renderItem = _props2.renderItem;

      var classNames = (0, _classnames2.default)('expandable-list-item', itemClassName);

      if (!this.state.expanded && index > collapseCount - 1) {
        return null;
      }

      var setRef = function setRef(ref) {
        if (index === collapseCount) {
          _this2.firstExpandedItem = ref;
        }
      };

      return _react2.default.createElement(
        'li',
        { key: getItemKey(item), className: classNames, ref: setRef },
        renderItem(item)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          list = _props3.list;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('cp-expandable-list', className) },
        _react2.default.createElement(
          'ul',
          null,
          list.map(this.renderListItem)
        ),
        this.renderExpandButton()
      );
    }
  }]);

  return ExpandableList;
}(_baseBcReactComponent2.default);

exports.default = ExpandableList;


ExpandableList.propTypes = {
  collapseCount: _react.PropTypes.number.isRequired,
  className: _react.PropTypes.string,
  itemClassName: _react.PropTypes.string,
  list: _react.PropTypes.oneOfType([_react.PropTypes.array, _reactImmutableProptypes2.default.list]).isRequired,
  renderItem: _react.PropTypes.func.isRequired,
  getItemKey: _react.PropTypes.func.isRequired,
  renderExpandButtonLabel: _react.PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/expandable/lib/components/expandable-list/components/ExpandableList.component.js
// module id = 1408
// module chunks = 1